import React from 'react';
import HotelForm from '../HotelForm/index'
import './style.css'

const HotelPage = ({ hotel_id }) => {
    return (
        <div id="Contact" className="contact-area">
            <div className="container">
                <div className="contact-content">
                    <h2 style={{ fontSize: '26px', marginBottom: '26px' }}>{hotel_id !== "false" ? "Update" : "Add"} Hotel Information</h2>
                    <div className="contact-form">
                        <HotelForm hotel_id={hotel_id} />
                    </div>
                </div>
            </div>
        </div>
    )
}

export default HotelPage;